"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitialsAvatar = void 0;
var React = __importStar(require("react"));
var InitialsAvatar_interface_1 = require("../InitialsAvatar.interface");
var InitialsAvatar_style_1 = __importDefault(require("./InitialsAvatar.style"));
exports.InitialsAvatar = function (props) {
    var name = props.name, dark = props.dark, _a = props.circle, circle = _a === void 0 ? true : _a, sizeCircle = props.sizeCircle, size = props.size, _b = props.style, style = _b === void 0 ? {} : _b, _c = props.skeleton, skeleton = _c === void 0 ? false : _c;
    var initials = skeleton ? '' : name[0].toUpperCase();
    var colorNumber = skeleton
        ? 0
        : name.split('').reduce(function (previousValue, currentValue) { return previousValue + currentValue.charCodeAt(0); }, 0);
    var color = skeleton ? '#eee' : InitialsAvatar_interface_1.colorInitialsAvatar[colorNumber % InitialsAvatar_interface_1.colorInitialsAvatar.length];
    style.color = {
        color: 'white',
    };
    if (!dark) {
        style.background = "" + color;
    }
    if (skeleton) {
        style.background = "#eee";
    }
    var classStyle = 'initials-letter';
    switch (size) {
        case 'xs':
        case 's':
        case 'm':
        case 'l':
        case 'xl':
            classStyle += " initials-" + size;
            break;
        default:
            classStyle += " initials-m";
    }
    if (sizeCircle) {
        style.width = sizeCircle + "px";
        style.height = sizeCircle + "px";
        style.lineHeight = sizeCircle + "px";
        style.fontSize = sizeCircle / 2 + "px";
    }
    return (React.createElement(InitialsAvatar_style_1.default, { circle: circle },
        React.createElement("div", { className: classStyle, style: style }, initials)));
};
//# sourceMappingURL=InitialsAvatar.js.map